import dayjs from 'dayjs'

export const DEFAULT_DATE_FORMAT = 'DD-MM-YYYY'
export const MONTH_YEAR_FORMAT = 'MM-YYYY'
export const FULL_DATE_DISPLAY_FORMAT = 'DD MMM YYYY'

/**
 * Formats a date using the provided format string or the default 'DD-MM-YYYY'.
 * @param {string|Date|dayjs.Dayjs} date - The date to format.
 * @param {string} [formatStr=DEFAULT_DATE_FORMAT] - The format string to use.
 * @returns {string} The formatted date string, or 'N/A' if the date is invalid.
 */
export const formatDate = (date, formatStr = DEFAULT_DATE_FORMAT) => {
    if (!date) return 'N/A'
    const d = dayjs(date)
    if (!d.isValid()) return 'N/A'
    return d.format(formatStr)
}

/**
 * Specifically for formatting to DD-MM-YYYY
 */
export const formatToStandard = (date) => formatDate(date, DEFAULT_DATE_FORMAT)

/**
 * Specifically for formatting to MM-YYYY (for monthly filters)
 */
export const formatToMonthYear = (date) => formatDate(date, MONTH_YEAR_FORMAT)

/**
 * Specifically for formatting to DD MMM YYYY (for better readability)
 */
export const formatToReadable = (date) => formatDate(date, FULL_DATE_DISPLAY_FORMAT)

/**
 * Parses a date string into a dayjs object.
 * @param {string|Date} date - The date to parse.
 * @returns {dayjs.Dayjs} The parsed dayjs object.
 */
export const parseDate = (date) => dayjs(date)

export default {
    DEFAULT_DATE_FORMAT,
    MONTH_YEAR_FORMAT,
    FULL_DATE_DISPLAY_FORMAT,
    formatDate,
    formatToStandard,
    formatToMonthYear,
    formatToReadable,
    parseDate,
}
